export default "__VITE_ASSET__04421c8c__"